import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';

@NgModule({
  imports: [CommonModule],
  exports: [],
  providers: [
    /* Eventually add core services like auth service here */
  ]
})
/**
 * The core module contains singleton services ( like auth ) and single use components ( like page-not-found )
 */
export class CoreModule {
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error('Core module should only be imported once');
    }
  }
}
